import React from 'react';
import { PageWrapper, Pagination } from '../../components';
import { bindActionCreators } from 'redux';
import Actions, { thunks } from '../../redux/modules/leads';
import { formatDate } from '../../utils/format';
import { connect } from 'react-redux';
class Leads extends React.Component {
    state = {
    }
    componentDidMount() {

        const { dispatch, match: { params: { id }} } = this.props;
        dispatch(thunks.getLeads(id));
    }
  render() {
    const {
        list,
        nextPageToken
    } = this.props;
      return(
        <PageWrapper title="Leads">
        {/* <Loader show={loading} /> */}
        {/* <Alert
            show={!!error}
            onHide={() => updateProperty('error', '')}
            title="Franchise Owner"
            message={error}
        /> */}
        <div className="animated fadeIn">
            <div className="row mt-3">
                <div className="col-md-12">
                    <div className="card">
                        <div className="card-body">
                            <div className="row align-items-center justify-content-end  pb-2">
                                {/* <div className="col-auto">
                                    <div className="form-group">
                                        <label>Status</label>
                                        <select
                                            className="form-control"
                                            value={verificationStatus}
                                            onChange={this.onStatusChange}>
                                            {AGENT_VERIFICATION_STATUS.map(status => <option key={status.value} value={status.value}>{status.name}</option>)}
                                        </select>
                                    </div>
                                </div> */}
                                {/* <div className="col-auto">
                                    <Link to={`/add-user/${3}`}>
                                        <button className="btn btn-primary">Add</button>
                                    </Link>
                                </div> */}
                            </div>
                            <div className="table-responsive">
                                <table className="table">
                                    <thead>
                                        <tr>
                                            <th>#</th>
                                            {/* <th>Image</th> */}
                                            <th>Name</th>
                                            <th>Phone</th>
                                            <th>WhatsApp No</th>
                                            <th>Email</th>
                                            <th>Client Type</th>
                                            <th>Work Site</th>
                                            <th>Site Type</th>
                                            <th>Date of visit</th>
                                            <th>Date of revisit</th>
                                            <th>Area</th>
                                            <th>Address</th>
                                            <th>Location</th>
                                            <th />
                                        </tr>
                                    </thead>
                                    <tbody>
                                    {
                                                    list.length ? (
                                                        list.map((lead,i) => (
                                                            <tr key={lead.id}>
                                                                <td>{i+1}</td>
                                                                {/* <td>
                                                                    {agent.profilePicture ? <img src={agent.profilePicture} alt="profile" width="50px" /> : '-'}
                                                                </td> */}
                                                                <td>{lead.name}</td>
                                                                <td>{'+' + lead.country_code + '-' + lead.phone_number}</td>
                                                                <td>{'+' + lead.country_code + '-' + lead.whatsapp_number}</td>
                                                                <td>{lead.email}</td>
                                                                <td>{lead.client_type}</td>
                                                                <td>{lead.work_site}</td>
                                                                <td>{lead.site_type}</td>
                                                                <td>{formatDate(lead.date_of_visit)}</td>
                                                                <td>{formatDate(lead.date_of_revisit)}</td>
                                                                <td>{lead.cover_area}</td>
                                                                <td>{lead.address}</td>
                                                                <td><a target="_blank" href={`https://www.google.com/maps/search/?api=1&query=${lead.latitude},${lead.longitude}`}>Open Location</a> </td>
                                                            </tr>
                                                        ))
                                                    ) : (
                                                        <tr className="text-center">
                                                            <td colSpan="13">No Records Found</td>
                                                        </tr>
                                                    )
                                                }
                                    </tbody>
                                </table>
                            </div>
                            <Pagination
                                nextPageToken={nextPageToken}
                                onNext={this.onNext}
                            />
                       
                        </div>
                    </div>
                </div>
            </div>
        </div>
       
    </PageWrapper>
      )
  }
}
const mapStateToProps = ({
    leads: {
        loading,
        error,
        list,
        verificationStatus,
        nextPageToken,
    }
}) => ({
    loading,
    error,
    list,
    verificationStatus,
    nextPageToken
});
const mapDispatchToProps = dispatch => ({
    dispatch,
    updateProperty: bindActionCreators(Actions, dispatch).updateProperty,
    reset: bindActionCreators(Actions, dispatch).reset,
});
export default connect(mapStateToProps, mapDispatchToProps)(Leads)
// export default Leads